import { Marker } from "../../models/marker.model";
import { LogoPlacementPosition } from "../../../design-editor/models/Placement";
import React from "react";
import { LogoImage } from "../../../../components/Logo/LogoImage";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";

export interface LogoMarker_VM {
  marker: Marker;
  logoPlacements: LogoPlacementPosition;
  isLocked: boolean;
  isActive: boolean;
  markerRef: React.RefObject<HTMLDivElement>;
  onSelect: () => void;
  canRemove: boolean;
  onRemove?: () => void;
}

export function LogoMarker({
  marker,
  logoPlacements,
  isLocked,
  isActive,
  markerRef,
  onSelect,
  canRemove,
  onRemove,
}: LogoMarker_VM) {
  /*function getLogoBorderColor(): string {
    switch (logoPlacements) {
      case LogoPlacementPosition.INVALID:
        return "border-red";
      case LogoPlacementPosition.OVERLAPPING:
        return "border-red";
      case LogoPlacementPosition.VALID:
        return "border-green";
      case LogoPlacementPosition.UNKNOWN:
        return "border-gray-600";
      default:
        return "border-gray-600";
    }
  }

  function buildLogoBorder(): string {
    let borderAttributes = "border";
    if (isLocked) {
      if (isActive) {
        borderAttributes += " border-solid border-1 border-blue";
      } else {
        borderAttributes += " border-solid border-1 border-transparent";
      }
    } else {
      borderAttributes += " " + getLogoBorderColor();

      if (isActive) {
        borderAttributes += " border-solid border-2";
      } else {
        borderAttributes += " border-dashed border-1";
      }
    }

    return borderAttributes;
  }*/

  function buildLogoBg(): string {
    return logoPlacements === LogoPlacementPosition.VALID
      ? "bg-[#7BBB5840]"
      : "bg-[#C6353540]";
  }

  return (
    <div
      id={`box-${marker.id}`}
      ref={markerRef}
      className={`box box-border rounded absolute z-[2] ${
        isActive
          ? isLocked
            ? "ring-1 ring-blue-500" // Active & Locked
            : logoPlacements === LogoPlacementPosition.VALID
              ? "ring-2 ring-green" // Active & Valid
              : "ring-2 ring-red" // Active & Invalid/Overlapping
          : isLocked
            ? "ring-0 ring-transparent" // Inactive & Locked
            : logoPlacements === LogoPlacementPosition.VALID
              ? "ring-1 ring-green ring-dashed" // Inactive & Valid
              : "ring-1 ring-red ring-dashed" // Inactive & Invalid/Overlapping
      } ${buildLogoBg()} ${
        isActive ? (isLocked ? "" : "cursor-move") : "cursor-pointer"
      }`}
      onClick={(x) => onSelect()}
    >
      {canRemove && (
        <button
          type="button"
          className="absolute -top-1 -right-1 w-3 h-3 bg-slate-700 rounded-full flex items-center justify-center text-white hover:bg-red-600 transition-colors z-10"
          onClick={(event) => {
            event.stopPropagation();
            onRemove?.();
          }}
          aria-label="Remove logo"
        >
          <FontAwesomeIcon icon={faTimes} className="text-[8px]" />
        </button>
      )}
      <LogoImage
        className="w-full h-full object-contain"
        useDigit={true}
        logo={marker.logo}
      />
      {!isLocked && isActive && (
        <>
          {/*<div
            id={`item_rotater-${marker.id}`}
            className='item_rotater absolute w-[10px] h-[10px] bg-white border-solid border-2 rounded-md border-purple-500 left-full bottom-full -translate-x-1/3 translate-y-1/3'
          />*/}
          {/*
          {logoType === LogoType.NORMAL && (
            <div
              id={`item_resizer-${marker.id}`}
              className='absolute w-[10px] h-[10px] bg-white border-solid border-2 rounded-md left-full top-full -translate-x-1/3 -translate-y-1/3'
            />
          )}*/}
        </>
      )}
    </div>
  );
}
